/** Team API calls (typed). */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiTeamMember } from "./team.adapter";

export interface TeamListParams {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const teamApi = {
  list: (params: TeamListParams = {}) =>
    apiGet<PaginatedResponse<ApiTeamMember>>("/team", params as QueryParams),
  get: (id: string) => apiGet<ApiTeamMember>(`/team/${id}`),
  me: () => apiGet<ApiTeamMember>("/team/me"),
  create: (body: Record<string, unknown>) => apiPost<ApiTeamMember>("/team", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiTeamMember>(`/team/${id}`, body),
  archive: (id: string) => apiDelete<ApiTeamMember>(`/team/${id}`),
  restore: (id: string) => apiPost<ApiTeamMember>(`/team/${id}/restore`),
};
